import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, ArrowLeft } from 'lucide-react';
import { CommissionRatesTable } from '@/components/payment/CommissionRatesTable';

const SuperAdminPaymentConfig = () => {
  const { profile, loading, isImpersonating, effectiveRole } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect if not superadmin or if currently impersonating
  if (!profile || effectiveRole !== 'superadmin' || isImpersonating) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6">
          <Link to="/superadmin">
            <Button variant="outline" className="flex items-center gap-2 mb-4">
              <ArrowLeft className="h-4 w-4" />
              Back to Super Admin
            </Button>
          </Link>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <Shield className="h-8 w-8 text-red-600" />
            Payment Configuration
          </h1>
          <p className="text-muted-foreground mt-2">
            Platform-wide commission configuration and payment oversight
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="h-5 w-5" />
              Payment Configuration
            </CardTitle>
            <CardDescription>
              Platform-wide commission configuration and payment oversight
            </CardDescription>
          </CardHeader>
          <CardContent>
            <CommissionRatesTable title="Platform Default Commission Rates" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SuperAdminPaymentConfig;